import React from 'react'
import styled from '@emotion/styled'
import { Shapes } from 'src/components/theme'
import { PaymentMethods } from 'src/views/settings/billing/payment-methods'
import { PaymentsLoading } from 'src/views/subscriptions/loading'

const Wrapper = styled.div`
  position: relative;
  min-height: ${Shapes.spacing[7]}px;
`
export const SubscriptionManagePaymentMethods = () => {
  return (
    <Wrapper>
      <React.Suspense fallback={<PaymentsLoading />}>
        <PaymentMethods hideDelete defaultAsRadio cardListMaxHeight={300} />
      </React.Suspense>
    </Wrapper>
  )
}
